import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import { Control, LocalForm, Errors } from 'react-redux-form';
import PropTypes from 'prop-types';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import './assesment.css';
import { Link } from 'react-router-dom';
import FilesTable from './table';
import { config } from '../../../utility/swaggerClient';
import axios from 'axios';
import moment from 'moment';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import warningLogo from '../../../assets/images/warning.png';
import {Checkbox} from "@material-ui/core";

let messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.headerAna',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Assessment'
  },
  headerTitleUploadDesign: {
    id: 'project.management.project.upload.design',
    description: '',
    defaultMessage: 'Upload Design'
  },
  headerSubTitleUploadDesign: {
    id: 'project.management.project.upload.design.subtitle',
    description: '',
    defaultMessage: 'Upload data pipeline design spreadsheet'
  },
  headerTitle: {
    id: 'project.management.project.creatation',
    description: 'Page Header Title',
    defaultMessage: 'Project Creatation/Update'
  },
  headerSubTitle: {
    id: 'assessment.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Finalize project details to generate your Analyzer Report'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});
let submitSuccessMsg =
  'Project creation or update successfully. Click Ok to go back to Project Management Home.';
let submitErrorMsg =
  'Project name already exist already. Please use a new name to create a project.';
let checkfreemsg =
  'Project creation or update successfully. Click Ok to go back to Project Management Home.';
let submitSuccessMsgForUploadDesign =
  'The data pipeline design spreadsheet has been uploaded successfully.';
let loaderExceptionMsg = '';
let exceptionMsg = '';

class Assesment extends Component {
  componentDidMount() {
    console.log('componentDidMount call');
    console.log(this.state);
    console.log(this.props);

    if (this.props.match.url.includes('uploaddesign')) {
      axios
        .get(
          `${config.protocol}://${config.host}/api/project/${
            this.props.match.params.project
          }`
        )
        .then(response => {
          console.log('response data');
          console.log(response.data.data);
          this.setState({
            projectName: response.data.data.projectName,
            dataFactoryId: this.props.match.params.dataFactoryId,
            id: response.data.data.id,
            isUploadDesignPage: true,
            dataFactory: this.props.match.params.dataFactory,
            currentversion: response.data.data.version

          });
        });

      console.log('upload design page render');
      
      return;
    } else if (this.props.match.url.includes('viewstm')) {
      console.log('viewstm page render');
      console.log(this.props)
      console.log(this.state)
      this.setState({
        status: {
          loading: true,
          // companyname: this.props.location.state[0].companyname,
          customer  : this.props.location.state[0].customer
        }
      });
      this.setState({ showFirstPage: false });
      this.setState({ showSecondPage: true });
      this.setState({ showMessage: false });
      this.setState({ id: -1 });
      axios
        .get(
          `${config.protocol}://${config.host}/api/project/${
            this.props.match.params.project
          }`
        )
        .then(response => {
          console.log('response data');
          console.log(response.data.data);
          this.setState({
            dataFactory: this.props.match.params.dataFactory,
            projectName: response.data.data.projectName,
            currentversion: response.data.data.version
          });
        });

      let project = {
        id: this.props.match.params.project
      };
      console.log(project);

      axios
        .post(
          `${config.protocol}://${config.host}/api/project/getDSLJSON`,
          project
        )
        .then(response => {
          console.log('response getDslJSON');
          var data = '[' + response.data.data + ']';

          var jsonData = JSON.parse(data);
          console.log(jsonData);
          //this.createTableData
          this.setState({
            uploadContentJsonList: this.createTableData(jsonData[0])
          });
          this.setState({ isViewSTMPage: true });
          this.setState({
            status: {
              loading: false
            }
          });
        });
    } else if (this.props.match.params.project !== '-1') {
      axios
        .get(
          `${config.protocol}://${config.host}/api/project/${
            this.props.match.params.project
          }`
        )
        .then(response => {
          console.log('response data');
          console.log(response.data.data);
          this.setState({
            dataFactory: this.props.match.params.dataFactory,
            projectName: response.data.data.projectName,
            applicationName: response.data.data.applicationName,
            currentversion: response.data.data.currentversion,
            comments: response.data.data.comments,
            id: response.data.data.id
          });
        });
    } else {
      console.log('this props');
      console.log(this.props);
      this.setState({
        dataFactoryId: this.props.match.params.dataFactoryId,
        dataFactory: this.props.match.params.dataFactory,
        currentversion: '1.0',
        id: -1
      });
    }

    messages = defineMessages({
      htmlHeader: {
        id: 'preview.html.headerAna11',
        description:
          'The title of the page that appears in the html header of the page.',
        defaultMessage: 'Project Management'
      },
      headerTitleUploadDesign: {
        id: 'project.management.project.upload.design',
        description: '',
        defaultMessage: 'Upload Design'
      },
      headerSubTitleUploadDesign: {
        id: 'project.management.project.upload.design.subtitle',
        description: '',
        defaultMessage: 'Upload data pipeline design spreadsheet'
      },

      headerTitle: {
        id: 'project.management.project.creation',
        description: 'Page Header Title',
        defaultMessage: 'Project Creation'
      },
      headerSubTitle: {
        id: 'Create a project or update STM',
        description: 'Page Header Subtitle',
        defaultMessage: 'Create a project or update STM'
      },
      searchFiles: {
        id: 'preview.search.files',
        description: 'search files',
        defaultMessage: 'Search Files'
      },
      alertTitle: {
        id: 'preview.alert.title',
        description: 'Preview API alert title',
        defaultMessage: 'Loading Project Files Failed'
      }
    });
  }

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.updateFile = this.updateFile.bind(this);
    this.state = {
      show: false,
      showUpload: false,
      projectName: '',
      targetLanguage: '',
      srclang: '',
      description: '',
      customer: '',
      showFiles: false,
      stagingrepo: '',
      repo: '',
      showMessage: false,
      refId: '',
      uploadType: '',
      uploadcontent: '',
      validfree: true,
      disableUploadBack: false,
      disableupload: false,
      showFirstPage: true,
      showSecondPage: false,
      dataFactory: '',
      applicationName: '',
      currentversion: '',
      comments: '',
      uploadContentJsonList: [],
      uploadFile: '',
      uploadFileName: '',
      dslJson: '',
      currentGitlabJsonList: [],
      isUploadDesignPage: false,
      isViewSTMPage: false,
      showMessageForUploadDesignPage: false,
      showErrorMessage: false,
      enableUploadDesignNotification: false,
      status: {
        loading: false
      },
      showModal: false,
      showLoaderException: false
    };
  }

  setDisableupload = val => {
    this.setState({ disableupload: val });
  };

  setPrjName = name => {
    this.setState({ projectName: name });
  };

  setDisableUploadBack = val => {
    this.setState({ disableUploadBack: val });
  };

  setUploadcontent = s => {
    this.setState({ uploadcontent: s });
  };

  showUploadTrue = type => {
    messages.headerSubTitle.id = type;
    if (type === 'upload') {
      this.setState({ showUpload: true, uploadType: type, projectName: '' });
    } else {
      this.setState({
        showUpload: true,
        uploadType: type,
        projectName: this.state.repo
      });
    }
  };

  showMessageTrue = e => {
    this.setState({ showMessage: true, refId: e.value.data });
  };

  showNPupload = type => {
    messages.headerSubTitle.id = type;
    const prj =
      type === 'upload'
        ? this.state.repo + '_' + Date.now()
        : this.state.stagingrepo;
    this.setState({ showUpload: true, uploadType: type, projectName: prj });
  };

  getFilesList = () => {
    console.log('call getFilesList');
    this.setState({ showFiles: true });
    console.log(this.state.showFiles);
    //this.props.getfilesList(this.state.repo,this.props.customerid);
  };

  selectCus = e => {
    this.props.resetStagingPrjList();
    const jobType =
      this.props.userType === 'standard' ? 'Assessment' : 'FreeAssessment';
    this.setState({ customer: e.target.value });
    this.props.customersPrjList(jobType, e.target.value);
  };

  confirmation = () => {};
  confirmationSubmit = () => {
    const jobType =
      this.props.userType === 'standard' ? 'Assessment' : 'FreeAssessment';
    this.props.userRequest(
      this.props.username,
      this.state.repo,
      this.state.srclang,
      this.state.targetLanguage,
      this.state.description,
      jobType,
      this.props.customerid,
      this.showMessageTrue
    );
  };

  submitRequest = () => {
    console.log('call submitRequest');
    this.setState({ showMessage: true });
    this.setState({ showFirstPage: false });
    this.setState({ showSecondPage: false });

    // this.confirmation();
  };

  getStagingRepo = (jobtype, repo) => {
    const jobType =
      this.props.userType === 'standard' ? 'Assessment' : 'FreeAssessment';
    this.setState({ stagingrepo: '' });
    this.setState({ repo: repo });
    this.props.getinfobyreponameforaccessment(
      repo,
      this.state.customer,
      jobType,
      this.updateSrcTar
    );
    this.props.getStagingPrjList(jobType, repo, this.state.customer);
  };

  updateSrcTar = e => {
    console.log(e);
    this.setState({
      targetLanguage: e.value.data.tgtlang,
      srclang: e.value.data.srclang,
      description: e.value.data.description
    });
  };

  gotoFileList = () => {
    this.getFilesList();
  };

  downloadSTMFile = event => {
    console.log(this.props);
    let project = {
      id: this.props.match.params.project
    };

    axios({
      url: `${config.protocol}://${config.host}/api/project/getSTMFile`, // Interface name
      method: 'post',
      data: project,
      responseType: 'blob'
    }).then(response => {
      console.log(response);
      const FileDownload = require('js-file-download');
      FileDownload(response.data, this.state.projectName + '.xlsx');
    });
  };

  createTableData = response => {
    let cols = [];
    let colObjs = {};
    response.columnObj.Column.items.forEach(col => {
      let key = col['_id'];
      colObjs[key] = col;
    });

    response.mappingObj.Mapping.items.forEach(col => {
      let obj = {};
      obj['rule_expression'] = col['rule_expression'];
      //obj["step"] = col["_context"][0]["_name"];

      let tgt = col['target_columns']['items'][0];

      let tgt_table = colObjs[tgt['_id']]['_context'][2]['_name'];
      let tgt_db = colObjs[tgt['_id']]['_context'][1]['_name'];
      obj['tgt'] = tgt_db + '.' + tgt_table + '.' + tgt['_name'].toLowerCase();
      obj['src'] = '';
      if (col['source_columns']['items'].length > 0) {
        let src = col['source_columns']['items'][0];
        // let src_table = colObjs[tgt['_id']]['_context'][2]['_name'];
        // let src_db = colObjs[tgt['_id']]['_context'][1]['_name'];
        // obj['src'] =
        //   src_db + '.' + src_table + '.' + src['_name'].toLowerCase();
        if(!src.hasOwnProperty("_id")){
          console.log(src)
          console.log(col)
          obj["src"]= "derived";
        }else{
          let src_table = colObjs[src["_id"]]["_context"][2]["_name"];
          let src_db = colObjs[src["_id"]]["_context"][1]["_name"];
          obj["src"]= src_db + "." + src_table + "." + src["_name"];
        }
        if (colObjs[src['_id']]) {
          if (colObjs[src['_id']]['data_type'] !== 'data frame')
            obj['source_data_type'] = colObjs[src['_id']]['data_type'];
        }
        if (colObjs[tgt['_id']]) {
          if (colObjs[tgt['_id']]['data_type'] !== 'data frame')
            obj['target_data_type'] = colObjs[tgt['_id']]['data_type'];
        }
      }

      cols.push(obj);
    });
    console.log('what is in cols');
    console.log(cols);
    // this.setState({ uploadContentJsonList: response.data.mappingObj.Mapping.items })
    //this.setState({ uploadContentJsonList: cols })
    return cols;
  };

  gotoSecondPage = event => {
    console.log('go second page clicked');
    //console.log(this.state)
    //console.log(this.props)
    // console.log(this.props.location.state[0].customer);
    //console.log(this.state.projectName === '');
    if (
      this.state.projectName === '' ||
      this.state.applicationName === '' ||
      this.state.uploadFile === ''
    ) {
      return;
    } else {
      this.setState({
        status: {
          loading: true,
          customer:this.props.match.params.customer
        }
      });

      console.log('onClick Next Button');
      const file = document.querySelector('#file');
      console.log(this.props.match.params.dataFactoryId);
      let groupName = '';
      if (file.files[0] !== undefined) {
        axios
          .get(
            `${config.protocol}://${config.host}/api/project/getgroupnamebydatafactoryid/${
              this.props.match.params.dataFactoryId
            }`
          )
          .then(response => {
            console.log('response getgroup');
            console.log(response.data);
            console.log(this.state.dataFactory);
            groupName = response.data;


            var formData = new FormData();
            formData.append('file', file.files[0]);

            if (this.props.match.params.project === '-1') {
              axios
                .post(
                  `${config.STMhost}/v1/templateGen/${groupName}/${
                    this.state.dataFactory
                  }`,
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  }
                )
                .then(response => {
                  console.log(response);
                  this.setState({ dslJson: response.data });

                  this.setState({
                    uploadContentJsonList: this.createTableData(response.data),
                    customer  : this.props.match.params.customer
                  });
                  // this.createTableData(response)
                  this.setState({ showFirstPage: false });
                  this.setState({ showSecondPage: true });
                  this.setState({ showMessage: false });
                  this.setState({
                    status: {
                      loading: false
                    }
                  });
                })
                .catch(error => {
                  console.log('call error');
                  console.log(error.response);
                  loaderExceptionMsg = error.response.data.description
                  this.setState({ showLoaderException: true });
                  this.setState({
                    status: {
                      loading: false
                    }
                  });
                });
            } else {
              console.log('this is testing next update');

              let project = {
                applicationName: this.state.applicationName,
                comments: this.state.comments,
                currentversion: this.state.currentversion,
                dataFactory: this.state.dataFactory,
                id: this.props.match.params.project,
                projectName: this.state.projectName,
                select: false,

                updatedBy: this.props.name,
                version: this.state.currentversion,
                dslJsonString: ''
              };
              console.log(project);

              const blob = new Blob([JSON.stringify(project)], {
                type: 'application/json'
              });

              var formData = new FormData();
              formData.append('project', blob);
              formData.append('file', this.state.uploadFile);

              axios
                .post(
                  `${config.protocol}://${
                    config.host
                  }/api/project/isSameSTMFileOrGet`,
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  }
                )
                .then(response => {
                  console.log('call success');
                  console.log(response);
                  if (response.data.code == 455) {
                    console.log('Same of the Content');

                    exceptionMsg =
                      'The upload file is the same as the previous version.';
                    this.setState({ showFirstPage: true });
                    this.setState({ showSecondPage: false });
                    this.setState({ showModal: true });
                    this.setState({
                      status: {
                        loading: false
                      }
                    });
                    return;
                  } else {
                    var data = '[' + response.data.data + ']';
                    var jsonData = JSON.parse(data);
                    console.log(jsonData[0]);
                    this.setState({
                      currentGitlabJsonList: this.createTableData(jsonData[0])
                    });

                    console.log('call template Gen');
                    axios
                      .post(
                        `${config.STMhost}/v1/templateGen/${groupName}/${
                          this.state.dataFactory
                        }`,
                        formData,
                        {
                          headers: {
                            'Content-Type': 'multipart/form-data'
                          }
                        }
                      )
                      .then(response => {
                        //console.log(response);
                         console.log('response update test')
                         console.log(this.state)
                         console.log(this.props.location.state[0].customer) 
                        this.setState({ dslJson: response.data });
                        this.setState({
                          uploadContentJsonList: this.createTableData(response.data),
                          customer: this.props.match.params.customer
                        });
                        this.setState({ showFirstPage: false });
                        this.setState({ showSecondPage: true });
                        this.setState({ showMessage: false });

                        this.setState({
                          status: {
                            loading: false
                          }
                        });
                      })
                      .catch(error => {
                        console.log(error.response);
                        loaderExceptionMsg = error.response.data.description
                        this.setState({ showLoaderException: true });
                        this.setState({
                          status: {
                            loading: false
                          }
                        });
                      });
                  }
                });
            }



          });

        // var formData = new FormData();
        // formData.append('file', file.files[0]);

        // if (this.props.match.params.project === '-1') {
        //   axios
        //     .post(
        //       `${config.STMhost}/v1/templateGen/${groupName}/${
        //         this.state.dataFactory
        //       }`,
        //       formData,
        //       {
        //         headers: {
        //           'Content-Type': 'multipart/form-data'
        //         }
        //       }
        //     )
        //     .then(response => {
        //       console.log(response);
        //       this.setState({ dslJson: response.data });

        //       this.setState({
        //         uploadContentJsonList: this.createTableData(response.data)
        //       });
        //       // this.createTableData(response)
        //       this.setState({ showFirstPage: false });
        //       this.setState({ showSecondPage: true });
        //       this.setState({ showMessage: false });
        //       this.setState({
        //         status: {
        //           loading: false
        //         }
        //       });
        //     })
        //     .catch(error => {
        //       console.log('call error');
        //       console.log(error.response);
        //       this.setState({ showLoaderException: true });
        //       this.setState({
        //         status: {
        //           loading: false
        //         }
        //       });
        //     });
        // } else {
        //   console.log('this is testing next update');

        //   let project = {
        //     applicationName: this.state.applicationName,
        //     comments: this.state.comments,
        //     currentversion: this.state.currentversion,
        //     dataFactory: this.state.dataFactory,
        //     id: this.props.match.params.project,
        //     projectName: this.state.projectName,
        //     select: false,

        //     updatedBy: this.props.name,
        //     version: this.state.currentversion,
        //     dslJsonString: ''
        //   };
        //   console.log(project);

        //   const blob = new Blob([JSON.stringify(project)], {
        //     type: 'application/json'
        //   });

        //   var formData = new FormData();
        //   formData.append('project', blob);
        //   formData.append('file', this.state.uploadFile);

        //   axios
        //     .post(
        //       `${config.protocol}://${
        //         config.host
        //       }/api/project/isSameSTMFileOrGet`,
        //       formData,
        //       {
        //         headers: {
        //           'Content-Type': 'multipart/form-data'
        //         }
        //       }
        //     )
        //     .then(response => {
        //       console.log('call success');
        //       console.log(response);
        //       if (response.data.code == 455) {
        //         console.log('Same of the Content');

        //         exceptionMsg =
        //           'The upload file is the same as the previous version.';
        //         this.setState({ showFirstPage: true });
        //         this.setState({ showSecondPage: false });
        //         this.setState({ showModal: true });
        //         this.setState({
        //           status: {
        //             loading: false
        //           }
        //         });
        //         return;
        //       } else {
        //         var data = '[' + response.data.data + ']';
        //         var jsonData = JSON.parse(data);
        //         console.log(jsonData[0]);
        //         this.setState({
        //           currentGitlabJsonList: this.createTableData(jsonData[0])
        //         });

        //         console.log('call template Gen');
        //         axios
        //           .post(
        //             `${config.STMhost}/v1/templateGen/${
        //               this.state.dataFactory
        //             }`,
        //             formData,
        //             {
        //               headers: {
        //                 'Content-Type': 'multipart/form-data'
        //               }
        //             }
        //           )
        //           .then(response => {
        //             console.log(response);
        //             this.setState({ dslJson: response.data });
        //             this.setState({
        //               uploadContentJsonList: this.createTableData(response.data)
        //             });
        //             this.setState({ showFirstPage: false });
        //             this.setState({ showSecondPage: true });
        //             this.setState({ showMessage: false });

        //             this.setState({
        //               status: {
        //                 loading: false
        //               }
        //             });
        //           })
        //           .catch(error => {
        //             console.log(error.response);
        //             this.setState({ showLoaderException: true });
        //             this.setState({
        //               status: {
        //                 loading: false
        //               }
        //             });
        //           });
        //       }
        //     });
        // }
      } else {
        console.log('No file attached');
        this.setState({ showFirstPage: false });
        this.setState({ showSecondPage: true });
        this.setState({ showMessage: false });
        this.setState({
          status: {
            loading: false
          }
        });
      }
    }
  };

  gotoFirstPage = () => {
    console.log('gotoFristPage')
    console.log(this.state)
    console.log(this.props)
    if (this.state.isViewSTMPage) {
      this.props.history.push({
        pathname: `/en-CA/projectmanagement/` +  this.props.match.params.dataFactory + '/' + this.props.match.params.dataFactoryId,
        state:[{
          customer:this.props.location.state[0].customer
        }]
      })
      // this.props.history.push(`/en-CA/projectmanagement/` + this.props.match.params.dataFactory + '/' + this.props.match.params.dataFactoryId
      // );
    } else {
      this.setState({ showFirstPage: true });
      this.setState({ showSecondPage: false });
      this.setState({ showMessage: false });
    }
  };

  onChangeItem = values => {
    console.log('onchange');
    console.log(values);
    this.setState({ ...this.state, ...values });
  };

  updateFile = event => {
    let file = event.target.files[0];
    this.setState({ uploadFile: file });
    console.log('update File change');
    console.log(this.state);
  };

  onSubmitItem(values) {
    console.log('start onSubmit');
    console.log(this.state);
    console.log(this.props);
    if (this.state.showFirstPage && !this.state.isUploadDesignPage) {
      return;
    }

    this.setState({
      status: {
        loading: true
      }
    });

    if (this.state.isUploadDesignPage) {
      console.log('onSubmite upload design');
      console.log(this.state);
      if(this.state.uploadFile !== null && this.state.uploadFile.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
        exceptionMsg =
            'The data pipeline spreadsheet uploaded is not valid';
          this.setState({ showModal: true });
          this.setState({
            status: {
              loading: false
            }
          })
          return
      }
      let project = {
        datafactoryId: this.state.dataFactoryId,
        dataFactory: this.state.dataFactory,
        id: this.props.match.params.project,
        projectName: this.state.projectName,
        username: this.props.username,
        enableUploadDesignNotification: this.state.enableUploadDesignNotification,
        version: this.state.currentversion
      };

      console.log(project);

      const blob = new Blob([JSON.stringify(project)], {
        type: 'application/json'
      });

      var formData = new FormData();
      console.log('create with file attached');
      console.log(this.state);

      formData.append('project', blob);
      formData.append('file', this.state.uploadFile);

      axios
        .post(
          `${config.protocol}://${config.host}/api/project/uploaddesign`,
          // axios.post('http://localhost:8082/leadshub/api/v1/project/add',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(response => {
          console.log('call success');
          console.log(response);
          this.setState({ showMessageForUploadDesignPage: true });
          this.setState({ isUploadDesignPage: false });
          this.setState({ showFirstPage: false });
          this.setState({ showSecondPage: false });
          this.setState({ showModal: false });
          this.setState({
            status: {
              loading: false
            }
          });
        })
        .catch(error => {
          console.log('call error upload desgin');
          console.log(error.response.data.description);
          
          exceptionMsg =
            (error.response.data.description === undefined) ? error.response.data.msg : error.response.data.description;
          this.setState({ showModal: true });
          this.setState({
            status: {
              loading: false
            }
          });
        })
    } else {
      console.log('check project content');
      console.log(this.state);
      let project = {
        datafactoryId: this.props.match.params.dataFactoryId,
        dataFactory: this.state.dataFactory,
        projectName: this.state.projectName,
        applicationName: this.state.applicationName,
        comments: this.state.comments,
        stm: this.state.uploadFile.name,
        lastUpdatedTime: moment(new Date()).format('YYYY/MM/DD HH:MM:SS'),
        updatedBy: this.props.name,
        select: false,
        currentversion: this.state.currentversion,
        dslJsonString: JSON.stringify(this.state.dslJson),
        username: this.props.username
      };

      console.log(this.props);

      if (this.props.match.params.project === '-1') {
        console.log('create project');
        project.id = this.props.match.params.project;
      } else {
        console.log('update project');
        project.id = this.props.match.params.project;
      }

      console.log(project);

      const blob = new Blob([JSON.stringify(project)], {
        type: 'application/json'
      });

      var formData = new FormData();
      console.log('create with file attached');
      console.log(this.state);

      formData.append('project', blob);
      //formData.append('file', this.state.uploadFile[0]);
      formData.append('file', this.state.uploadFile);
      axios
        .post(
          `${config.protocol}://${config.host}/api/project/add`,
          // axios.post('http://localhost:8082/leadshub/api/v1/project/add',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(response => {
          console.log('call success');

          this.setState({ showMessage: true });
          this.setState({ showFirstPage: false });
          this.setState({ showSecondPage: false });
          this.setState({
            status: {
              loading: false
            }
          });
        })
        .catch(error => {
          console.log('call error');
          console.log(error.response);
          if(error.response.status === 455 || error.response.status === 456){
            exceptionMsg = error.response.data;
          }
          else
          exceptionMsg =
            'Project name can not be the same. Please use another project name.';
          this.setState({ showModal: true });
          this.setState({
            status: {
              loading: false
            }
          });
        });
    }
  }

  render() {
    const jobType =
      this.props.userType === 'standard' ? 'Assessment' : 'FreeAssessment';
    const myData = this.state.uploadContentJsonList;
    const myData2 = this.state.currentGitlabJsonList;

    return (
      <div className={this.state.show ? 'pageHide' : 'page'}>
        <Helmet>
          <title>Project Management - FUSE</title>
        </Helmet>
        {this.state.isUploadDesignPage && (
          <Header
            title={this.props.intl.formatMessage(
              messages.headerTitleUploadDesign
            )}
            subtitle={this.props.intl.formatMessage(
              messages.headerSubTitleUploadDesign
            )}
            icon="preview"
            locale={this.props.locale}
            status={this.state.status}
          />
        )}
        {!this.state.isUploadDesignPage && (
          <Header
            title={this.props.intl.formatMessage(messages.headerTitle)}
            subtitle={
              this.state.isViewSTMPage
                ? 'View STM'
                : this.props.intl.formatMessage(messages.headerSubTitle)
            }
            icon="preview"
            locale={this.props.locale}
            status={this.state.status}
          />
        )}

        <Modal style={{ width: '600px' }} isOpen={this.state.showLoaderException}>
          <ModalHeader>
            <div style={{ width: '400px' }}>
              <img alt="SHIFT" src={warningLogo} className="modal_logo" />{' '}
              Exception{' '}
            </div>
          </ModalHeader>

          <ModalBody>
            <div style={{ padding: '5px' }}>
              The STM spreadsheet uploaded is not valid, following are the errors:
              <p style={{ paddingLeft: '15px' }}>
                <ul>
                  <li style={{ wordWrap: 'break-word' }}>{loaderExceptionMsg}</li>
                </ul>
              </p>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="button-container" style={{ textAlign: 'center' }}>
              <button
                className="button"
                style={{ marginLeft: 'auto', marginRight: '200px' }}
                type="submit"
                onClick={() => this.setState({ showLoaderException: false })}
              >
                <FormattedMessage id="nav.ok" defaultMessage="OK" />
              </button>
            </div>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.showModal}>
          <ModalHeader>
            <div style={{ width: '372px' }}>
              <img alt="SHIFT" src={warningLogo} className="modal_logo" />{' '}
              Exception{' '}
            </div>
          </ModalHeader>

          <ModalBody>
            <div style={{ whiteSpace: 'pre-wrap' }}>{exceptionMsg}</div>
          </ModalBody>
          <ModalFooter>
            <div className="button-container" style={{ textAlign: 'center' }}>
              <button
                className="button"
                style={{ marginLeft: 'auto', marginRight: '200px' }}
                type="submit"
                onClick={() => this.setState({ showModal: false })}
              >
                <FormattedMessage id="nav.ok" defaultMessage="OK" />
              </button>
            </div>
          </ModalFooter>
        </Modal>

        <div className="main">
          <div
            className="panel"
            style={{
              width: '95%',
              padding: '10px',
              boxSizing: 'content-box',
              marginTop: '15px',
              display: 'block',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <div>
              <LocalForm
                className="form"
                onSubmit={() => this.onSubmitItem()}
                onChange={values => this.onChangeItem(values)}
              >
                {this.state.isUploadDesignPage && (
                  <div
                    style={{
                      marginLeft: '3%'
                    }}
                  >
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="project.management.data.factory.name"
                          defaultMessage="Data Factory Name"
                        />
                      </label>
                      <Control.text
                        model=".dataFactory"
                        value={this.state.dataFactory}
                        disabled
                      />
                    </fieldset>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="create-project.form.name.title"
                          defaultMessage="Project Name"
                        />
                      </label>
                      <Control.text
                        model=".projectName"
                        value={this.state.projectName}
                        disabled
                      />
                    </fieldset>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="create-project.form.name.title.version"
                          defaultMessage="Current STM Version"
                        />
                      </label>
                      <Control.text
                        model=".projectName"
                        value={this.state.currentversion}
                        disabled
                      />
                    </fieldset>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="create-project.form.name.title.version"
                          defaultMessage="Data Pipeline Design Version"
                        />
                      </label>
                      <Control.text
                        model=".projectName"
                        value={this.state.currentversion}
                        disabled
                      />
                    </fieldset>
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Pipeline Design Spreadsheet
                      </label>

                      <input
                        type="file"
                        id="file"
                        name="file"
                        onChange={this.updateFile}
                      />
                      {/* <Control.file model=".uploadFile" value={this.state.projectName} /> */}
                    </fieldset>
                    <div style={{
                        marginLeft: '-16px'}}>
                        <Checkbox
                            checked={this.state.enableUploadDesignNotification}
                            color="primary"
                            inputProps={{
                              'aria-label': 'secondary checkbox'
                            }}
                            onChange={()=>{const v= this.state.enableUploadDesignNotification;this.setState({enableUploadDesignNotification:!v})}}
                          />
                        <label style={{ display: 'inline', textTransform: 'none' }}>
                          Notify customer's user to review the data pipeline design
                        </label>  
                       
                      {/* <input type="checkbox" id="chkbox" name="chkbox" value="Notify customer's user to review the data pipeline design"></input> */}
                    </div>
                    <div
                      className="button-container"
                      style={{ textAlign: 'center' }}
                    >
                      {/* <Link to="/en-CA/projectmanagement"> */}
                      <Link to={{
                      pathname: '/en-CA/projectmanagement/' + this.props.match.params.dataFactory + '/' + this.props.match.params.dataFactoryId,
                      state:[{
                        
                        customer : this.props.match.params.customer,
                        
                      }]
                    }}>
                        <button
                          className="button"
                          style={{ marginRight: '10px' }}
                          type="button"
                          // onClick={() => this.props.NPRequestList(this.state.customer)}
                          //disabled={this.state.refreshbtn}
                          // onClick={() => this.nprefresh()}
                        >
                          BACK
                        </button>
                      </Link>
                      <button
                        className="button"
                        type="submit"
                        // onClick={this.submitRequest}
                      >
                        <FormattedMessage
                          id="submit.button.name"
                          defaultMessage="Submit"
                        />
                      </button>
                    </div>
                  </div>
                )}

                {!this.state.isUploadDesignPage &&
                  this.state.showFirstPage &&
                  !this.state.showSecondPage && (
                    <div
                      style={{
                        marginLeft: '3%'
                      }}
                    >
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="project.management.data.factory.name"
                            defaultMessage="Data Factory Name"
                          />
                        </label>
                        <Control.text
                          model=".dataFactory"
                          value={this.state.dataFactory}
                          disabled
                        />
                      </fieldset>
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="create-project.form.name.title"
                            defaultMessage="Project Name"
                          />
                        </label>
                        <Control.text
                          model=".projectName"
                          value={this.state.projectName}
                          required
                          validators={{
                            length: val => `${val}`.length > 0
                          }}
                          // disabled
                        />
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="project.management.application.name"
                            defaultMessage="Application Name"
                          />
                        </label>

                        <Control.text
                          model=".applicationName"
                          value={this.state.applicationName}
                          required
                        />
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="project.management.source.to.target"
                            defaultMessage="Source to Target File:"
                          />
                        </label>

                        <input
                          type="file"
                          id="file"
                          name="file"
                          onChange={this.updateFile}
                        />

                        {/* <Control.file
                          id="file1"
                          name="file1"
                          model=".uploadFile"
                          // model={this.state.uploadFile.name}
                          //value={this.state.uploadFileName}
                          onChange={this.updateFile}
                          required /> */}
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="project.management.current.lastest.version"
                            defaultMessage={
                              'Current Version: ' + this.state.currentversion
                            }
                          />
                        </label>

                        <Control.text
                          model=".currentversion"
                          value={this.state.currentversion}
                          required
                          disabled
                        />
                      </fieldset>

                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="project.management.comments"
                            defaultMessage="Comments"
                          />
                        </label>

                        <Control.text
                          model=".comments"
                          value={this.state.comments}
                        />
                      </fieldset>

                      <div
                        className="button-container"
                        style={{ textAlign: 'center' }}
                      >
                        {/* <Link to='/en-CA/projectmanagement' + {this.props.match.params.dataFactory} + '/' + {this.props.match.params.dataFactoryId} + '/' + {this.props.match.params.customer}> */}
                        <Link to={{
                          pathname: '/en-CA/projectmanagement/back/' + this.props.match.params.dataFactory + '/' + this.props.match.params.dataFactoryId + '/' + this.props.match.params.customer,
                          // state:[{
                          
                          //   customer : this.props.match.params.customer
                            
                          // }]
                        }}>
                          <button
                            className="button"
                            style={{ marginRight: '10px' }}
                            type="button"
                            // onClick={() => this.props.NPRequestList(this.state.customer)}
                            //disabled={this.state.refreshbtn}
                            // onClick={() => this.nprefresh()}
                          >
                            BACK
                          </button>
                        </Link>

                        <button
                          className="button"
                          type="submit"
                          onClick={this.gotoSecondPage}
                          disabled={this.state.uploadFile === ''}
                        >
                          <FormattedMessage
                            id="onboard.next"
                            defaultMessage="next"
                          />
                        </button>
                      </div>
                    </div>
                  )}

                {this.state.showMessageForUploadDesignPage && (
                  <div className="form">
                    <label
                      style={{
                        width: '90%',
                        fontSize: '16px',
                        marginBottom:'10px',
                        textTransform: 'none',
                        lineHeight: '150%'
                      }}
                    >
                      {submitSuccessMsgForUploadDesign}
                    </label>
                    <br />
                    <div
                      className="button-container"
                      style={{ textAlign: 'center' }}
                    >
                      <Link to={{
                          pathname: '/en-CA/projectmanagement/back/' + this.props.match.params.dataFactory + '/' + this.props.match.params.dataFactoryId + '/' + this.props.match.params.customer,
                          // state:[{
                          
                          //   customer : this.props.match.params.customer
                            
                          // }]
                        }}>
                        <button
                          className="button"
                          style={{  marginRight: '10px' }}
                          type="button"
                          //onClick={this.props.clickBackHandler}
                        >
                          <FormattedMessage id="nav.ok2" defaultMessage="Back to Project Management Home" />
                        </button>
                      </Link>
                      <Link to={{
                          pathname: `/en-CA/datapipeline`,
                          state:[{
                            dataFactory : this.props.match.params.dataFactory,
                            dataFactoryId : this.props.match.params.dataFactoryId,
                            companyname : this.props.match.params.organization,
                            customer : this.props.match.params.customer,
                            project: this.props.match.params.projectName,
                            applicationName: this.props.match.params.applicationName
                          }]
                        }} >
                        <button
                          className="button"
                          style={{  marginRight: '10px' }}
                          type="button"
                          //onClick={this.props.clickBackHandler}
                        >
                          <FormattedMessage id="nav.ok2" defaultMessage="View Data Pipeline Design" />
                        </button>
                      </Link>
                    </div>
                  </div>
                )}

                {this.state.showErrorMessage && (
                  <div className="form">
                    <label
                      style={{
                        width: '90%',
                        fontSize: '16px',
                        textTransform: 'none',
                        lineHeight: '150%'
                      }}
                    >
                      {submitErrorMsg}
                    </label>
                    <div
                      className="button-container"
                      style={{ textAlign: 'center' }}
                    >
                      <Link to="/en-CA/projectmanagement">
                        <button
                          className="button"
                          styel={{ padding: 20 }}
                          type="button"
                          //onClick={this.props.clickBackHandler}
                        >
                          <FormattedMessage id="nav.ok" defaultMessage="OK" />
                        </button>
                      </Link>
                    </div>
                  </div>
                )}

                {this.state.showMessage && (
                  <div className="form">
                    <label
                      style={{
                        width: '90%',
                        fontSize: '16px',
                        textTransform: 'none',
                        lineHeight: '150%'
                      }}
                    >
                      {submitSuccessMsg}
                    </label>
                    <br />
                    <br />
                    <br />
                    <div
                      className="button-container"
                      style={{ textAlign: 'center' }}
                    >
                      <Link to={{
                      pathname: '/en-CA/projectmanagement/' + this.props.match.params.dataFactory + '/' + this.props.match.params.dataFactoryId,
                      state:[{
                        
                        customer : this.state.customer,
                       
                      }]
                    }}>
                        <button
                          className="button"
                          styel={{ padding: 20 }}
                          type="button"
                          //onClick={this.props.clickBackHandler}
                        >
                          <FormattedMessage id="nav.ok" defaultMessage="OK" />
                        </button>
                      </Link>
                    </div>
                  </div>
                )}

                {!this.state.isUploadDesignPage &&
                  this.state.showSecondPage &&
                  !this.state.showFirstPage && (
                    <div
                      style={{
                        marginLeft: '3%'
                      }}
                    >
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="project.management.data.factory.name"
                            defaultMessage="Data Factory Name"
                          />
                        </label>
                        <Control.text
                          model=".dataFactory"
                          value={this.state.dataFactory}
                          required
                          // disabled
                        />
                      </fieldset>
                      <fieldset>
                        <label style={{ textTransform: 'capitalize' }}>
                          <FormattedMessage
                            id="create-project.form.name.title"
                            defaultMessage="Project Name"
                          />
                        </label>
                        <Control.text
                          model=".projectName"
                          value={this.state.projectName}
                          required
                          // disabled
                        />
                      </fieldset>

                      <label style={{ textTransform: 'capitalize' }}>
                        <FormattedMessage
                          id="project.management.source.to.target"
                          defaultMessage="Source to Target File:"
                        />
                      </label>

                      {this.state.id === -1 && (
                        <div>
                          <label style={{ textTransform: 'capitalize' }}>
                            <FormattedMessage
                              id="create-project.form.name.title11"
                              defaultMessage={
                                'Current Version: ' + this.state.currentversion
                              }
                            />
                          </label>
                          <FilesTable>{myData}</FilesTable>
                        </div>
                      )}
                      {this.state.id !== -1 && (
                        <div>
                          <div className="leftTable">
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="create-project.form.name.title11"
                                defaultMessage={
                                  'Current Version: ' +
                                  this.state.currentversion
                                }
                              />
                            </label>
                            <FilesTable>{myData2}</FilesTable>
                          </div>
                          <div className="rightTable">
                            <label style={{ textTransform: 'capitalize' }}>
                              <FormattedMessage
                                id="create-project.form.name.title11"
                                defaultMessage={
                                  'New Version: ' +
                                  (
                                    Number(this.state.currentversion) + 1
                                  ).toFixed(1)
                                }
                              />
                            </label>
                            <FilesTable>{myData}</FilesTable>
                          </div>
                        </div>
                      )}
                      <div style={{ clear: 'both' }} />
                      <br />

                      <div
                        className="button-container"
                        style={{ textAlign: 'center' }}
                      >
                        <button
                          className="button"
                          style={{ marginRight: '10px' }}
                          type="button"
                          onClick={this.gotoFirstPage}
                        >
                          BACK
                        </button>
                        {!this.state.isViewSTMPage && (
                          <button
                            className="button"
                            type="submit"
                            // onClick={this.submitRequest}
                          >
                            <FormattedMessage
                              id="submit.button.name"
                              defaultMessage="Submit"
                            />
                          </button>
                        )}
                        {this.state.isViewSTMPage && (
                          <button
                            className="button"
                            type="button"
                            onClick={this.downloadSTMFile}
                          >
                            DOWNLOAD
                          </button>
                        )}
                      </div>
                    </div>
                  )}
              </LocalForm>
            </div>{' '}
          </div>{' '}
        </div>
        <Footer />
      </div>
    );
  }
}

Assesment.propTypes = {
  clickSubmitHandler: PropTypes.func.isRequired,
  projectList: PropTypes.array,
  title: PropTypes.string,
  opportunity: PropTypes.string,
  username: PropTypes.string,
  reponame: PropTypes.string,
  srclang: PropTypes.string,
  tgtlang: PropTypes.string,
  gitlabProjects: PropTypes.func.isRequired,
  gitlab_id: PropTypes.string,
  groupId: PropTypes.string,
  filesList: PropTypes.array
};

export default injectIntl(Assesment);



// WEBPACK FOOTER //
// ./src/components/views/Assesment/index.js